<template>
  <section class="lead-transfer-rules-notice">
    <div class="lead-transfer-rules-notice__content">
      <h3 class="lead-transfer-rules-notice__title">
        Вы являетесь участником автоматизированной системы передачи лидов «Лидер»
      </h3>
      <p class="lead-transfer-rules-notice__text">
        Мы ожидаем, что партнеры-участники будут придерживаться следующих ключевых правил:
      </p>
      <ul class="lead-transfer-rules-notice__list">
        <li class="lead-transfer-rules-notice__item">
          Качественно и в срок отрабатывать лиды, независимо от суммы сделки
        </li>
        <li class="lead-transfer-rules-notice__item">
          Осуществлять закупку ПО и оборудования для реализации сделки с заказчиком в Axoft
        </li>
        <li class="lead-transfer-rules-notice__item">
          В случае, если переданному вам заказчику вы осуществляете допродажу ПО или оборудования
          <span class="font-bold">из портфеля Axoft</span>, мы ожидаем приоритет закупки в Axoft
        </li>
      </ul>
    </div>
    <div class="lead-transfer-rules-notice__info">
      <span class="lead-transfer-rules-notice__info-circle" aria-hidden="true">
        <img src="/dist/img/circle.png" alt="Information img" />
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LeadTransferRulesNotice',
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.lead-transfer-rules-notice
  position: relative
  padding: 20px 46px
  background: #FFFFFF
  border-radius: 6px

  @media (max-width: $mobile-size)
    padding-inline-start: 16px

  &__info
    position: absolute
    right: 0
    bottom: 0

  &__content
    position: relative
    z-index: 1

  &__title
    font-weight: 600
    font-size: 24px

  &__text
    margin-top: 16px
    font-size: 16px
    font-weight: 700
    line-height: 1.5

  &__list
    padding-left: 24px
    max-width: calc(100% - 90px)
    font-size: 16px
    line-height: 1.5

    @media (max-width: $mobile-size)
      max-width: initial

  &__item
    &:before
      content: '\2022'
      position: absolute
      left: 8px
</style>



// WEBPACK FOOTER //
// src/modules/leads/ui/components/LeadTransferRulesNotice.vue